import * as React from 'react';
import styled from 'styled-components';
import { Box } from '@openfin/ui-library';

interface Props {
  depth: number;
}

export const StackEffect: React.FC<Props> = (props) => {
  const { depth, children } = props;

  return (
    <StackContainer flexDirection="column" alignItems="center">
      {children}
      {depth > 1 && <Stack style={{ zIndex: 2 }} />}
      {depth > 2 && <Stack style={{ zIndex: 1 }} />}
    </StackContainer>
  );
};

const StackContainer = styled(Box)`
  &:after {
    position: absolute;
    content: '';
    pointer-events: none;
    top: 1px;
    left: 1px;
    right: 1px;
    bottom: 1px;
    box-shadow: 0 0 1px 1px ${({ theme }) => theme.palette.background2};
    border-radius: ${({ theme }) => theme.radius.base};
  }
`;

const Stack = styled.div`
  border-bottom-left-radius: ${({ theme }) => theme.radius.base};
  border-bottom-right-radius: ${({ theme }) => theme.radius.base};
  background: ${({ theme }) => theme.palette.background4};
  border-top: none;
  width: 312px;
  height: ${({ theme }) => theme.px.base};
  box-shadow: inset 0 2px 3px 0px ${({ theme }) => theme.palette.background2};
`;
